"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
var Event = /** @class */ (function () {
    function Event(name, version, fields) {
        this.name = name;
        this.ts_ms = Date.now();
        this.version = version;
        this.fields = fields;
    }
    Event.getAttributeTypeMap = function () {
        return Event.attributeTypeMap;
    };
    Event.attributeTypeMap = [
        {
            name: 'name',
            baseName: 'name',
            type: 'string',
        },
        {
            name: 'ts_ms',
            baseName: 'ts_ms',
            type: 'number',
        },
        {
            name: 'version',
            baseName: 'version',
            type: 'number',
        },
        {
            name: 'fields',
            baseName: 'fields',
            type: 'object',
        },
    ];
    return Event;
}());
exports.Event = Event;
//# sourceMappingURL=event.js.map